import { render, staticRenderFns } from "./FetchSiteData.vue?vue&type=template&id=6b70a771"
import script from "./FetchSiteData.vue?vue&type=script&lang=js"
export * from "./FetchSiteData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports